import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    style: { "padding-bottom": "40px" }
};
const _hoisted_2 = { class: "saved-vehicles-header" };
const _hoisted_3 = { class: "saved-vehicles-title" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 1 };
import { ref, computed, onMounted, nextTick } from "vue";
import OrionNoSavedVehicles from "@/pages/savedVehicles/components/orionNoSavedVehicles.vue";
import { TranslationService } from "@/services/translationService";
import { CustomEvents } from "@/events/customEvents";
import { getDealerId } from "@/utils/dealerUtils";
// Loader for the Orion SRP vehicle card deck web component (see VehicleCardDeck.md).
const ORION_DECK_LOADER_SRC = "/resources/vhcliaa/components/orionVehicleCardDeck/orionVehicleCardDeckBundle.js";
export default /*@__PURE__*/ _defineComponent({
    __name: 'orionSavedVehiclesPage',
    setup(__props) {
        const translationService = new TranslationService();
        const dealerId = String(getDealerId());
        const vehicles = ref([]);
        const translations = ref();
        // Gate rendering until translations resolve so localized labels don't flash from their fallbacks.
        const ready = ref(false);
        const hasSavedVehicles = computed(() => vehicles.value.length > 0);
        const vinsCsv = computed(() => vehicles.value.join(","));
        // Orion doesn't need RV industry switch.
        const savedVehiclesLabel = computed(() => translations.value?.resources?.["label_savedVehicles"] || "Saved Vehicles");
        // H1 shows the live count of vehicles currently on the page (after invalid VINs are pruned).
        const pageTitle = computed(() => `${savedVehiclesLabel.value} (${vehicles.value.length})`);
        const clearAllLabel = computed(() => translations.value?.resources?.["label_clearAll"] || "Clear All");
        const backLabel = computed(() => translations.value?.resources?.["label_back"] || "Back");
        const loadVehicles = () => {
            vehicles.value = JSON.parse(localStorage.getItem("savedVehicles") ?? "[]");
        };
        const goBack = () => {
            globalThis.history.back();
        };
        const clearAll = () => {
            vehicles.value = [];
            localStorage.setItem("savedVehicles", "[]");
            // Keep any save hearts elsewhere in sync and drop to the empty state.
            document.dispatchEvent(new Event(CustomEvents.ToggleVehicleSave));
        };
        const injectOrionDeckLoader = () => {
            if (document.querySelector(`script[src="${ORION_DECK_LOADER_SRC}"]`))
                return;
            const script = document.createElement("script");
            script.src = ORION_DECK_LOADER_SRC;
            document.body.appendChild(script);
        };
        onMounted(async () => {
            loadVehicles();
            const response = await translationService.getTranslations(dealerId, "mysavedvehicles");
            translations.value = response ?? { resources: {} };
            ready.value = true;
            document.addEventListener(CustomEvents.ToggleVehicleSave, () => {
                loadVehicles();
            });
            // A vehicle that has sold or left inventory comes back as an invalid VIN; remove it silently so
            // the count and localStorage stay accurate.
            globalThis.addEventListener("do.vehicledeckloaded", (event) => {
                const invalidVins = event.data.invalidVins;
                vehicles.value = vehicles.value.filter((v) => !invalidVins.includes(v));
                localStorage.setItem("savedVehicles", JSON.stringify(vehicles.value));
            });
            // The Orion deck loader scans for <orion-vehicle-card-deck> on execution, so inject it only once
            // the element is in the DOM.
            if (hasSavedVehicles.value) {
                await nextTick();
                injectOrionDeckLoader();
            }
        });
        return (_ctx, _cache) => {
            const _component_orion_vehicle_card_deck = _resolveComponent("orion-vehicle-card-deck");
            return (ready.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "back-button stat-button-link",
                            "data-loc": "vehicle save header",
                            onClick: goBack
                        }, [
                            _cache[0] || (_cache[0] = _createElementVNode("i", {
                                "aria-hidden": "true",
                                class: "fa-solid fa-arrow-left"
                            }, null, -1 /* CACHED */)),
                            _createTextVNode(" " + _toDisplayString(backLabel.value), 1 /* TEXT */)
                        ]),
                        _createElementVNode("h1", _hoisted_3, [
                            _cache[1] || (_cache[1] = _createElementVNode("i", {
                                "aria-hidden": "true",
                                class: "fa-solid fa-heart saved-vehicles-heart"
                            }, null, -1 /* CACHED */)),
                            _createTextVNode(" " + _toDisplayString(pageTitle.value), 1 /* TEXT */)
                        ]),
                        (hasSavedVehicles.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "clear-all-button stat-button-link",
                                "data-loc": "vehicle save header",
                                onClick: clearAll
                            }, [
                                _cache[2] || (_cache[2] = _createElementVNode("i", {
                                    "aria-hidden": "true",
                                    class: "fa-solid fa-trash"
                                }, null, -1 /* CACHED */)),
                                _createTextVNode(" " + _toDisplayString(clearAllLabel.value), 1 /* TEXT */)
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    (hasSavedVehicles.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(_component_orion_vehicle_card_deck, {
                                vins: vinsCsv.value,
                                "dealer-id": _unref(dealerId)
                            }, null, 8 /* PROPS */, ["vins", "dealer-id"])
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(OrionNoSavedVehicles, {
                                translations: translations.value
                            }, null, 8 /* PROPS */, ["translations"])
                        ]))
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
